import { baseApi } from "@/config/http-common";
import { ChangeLocationPayload } from "@/types/documents/folder/DocumentFolder";

class DocumentFolderDataService {
  list(folderId?: string | null, page = 0, itemsLimit = 20): Promise<any> {
    const params: Record<string, string | number> = { page, itemsLimit };
    if (folderId) {
      params.id = folderId;
    }
    return baseApi.get("/documents/folder/list", { params });
  }

  view(folderId: string): Promise<any> {
    return baseApi.get(`/documents/folder/view/${folderId}`);
  }

  create(data: { title: string; parentFolderId: string | null }): Promise<any> {
    return baseApi.post("/documents/folder/create", data);
  }

  delete(folderId: string): Promise<any> {
    return baseApi.delete(`/documents/folder/delete/${folderId}`);
  }

  changeLocation(data: ChangeLocationPayload): Promise<any> {
    return baseApi.post("/documents/folder/change-location", data);
  }

  getAccess(folderId: string): Promise<any> {
    return baseApi.get(`/documents/folder/access/${folderId}`);
  }

  grantAccess(folderId: string, userList: string[]): Promise<any> {
    return baseApi.post("/documents/folder/access", { folderId, userList });
  }

  revokeAccess(folderAccessId: string): Promise<any> {
    return baseApi.delete(`/documents/folder/access/${folderAccessId}`);
  }

  downloadPackage(folderId: string): Promise<any> {
    return baseApi.get(`/documents/folder/download-package/${folderId}`);
  }
}

export default new DocumentFolderDataService();
